import React, { Component } from 'react';
import * as EmailVerificationActions from './EmailVerificationActions';

class EmailVerificationPage extends Component {
    componentWillMount = () => {
        console.log(
            'this.props.match.params.token',
            this.props.match.params.token
        );
        EmailVerificationActions.verifyToken(this.props.match.params.token);
    };
    render() {
        return <div className="email-confirmation-page page" />;
    }
}

export default EmailVerificationPage;



// WEBPACK FOOTER //
// ./src/modules/email-verification/EmailVerificationPage.jsx